import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'

let segmentAnalytics = null

function initAnalytics() {
  segmentAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      segmentPlugin({
        writeKey: process.env.REACT_APP_SEGMENT_KEY,
      }),
    ],
  })
}

function getAnalyticsInstance() {
  if (isSegmentInitialized()) {
    return segmentAnalytics
  }
}

function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

function identify(userId, traits = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.identify(userId, traits)
  }
}

function reset() {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.reset()
  }
}

export default {
  initAnalytics,
  track,
  page,
  identify,
  reset,
}
